import { GlAccountSortField } from "@/graphql/codegen/graphql"

// Mapping between TanStack Table accessor keys and backend sort fields
export enum ChartOfAccountsSortableAccessorKey {
  Number = "number",
  Title = "title",
  ParentAccount = "parentAccount",
  Type = "type",
}

export const sortFieldToAccessorKey = new Map<GlAccountSortField, ChartOfAccountsSortableAccessorKey>([
  [GlAccountSortField.Number, ChartOfAccountsSortableAccessorKey.Number],
  [GlAccountSortField.Title, ChartOfAccountsSortableAccessorKey.Title],
  [GlAccountSortField.ParentAccount, ChartOfAccountsSortableAccessorKey.ParentAccount],
  [GlAccountSortField.Type, ChartOfAccountsSortableAccessorKey.Type],
])

export const accessorKeyToSortField = new Map<ChartOfAccountsSortableAccessorKey, GlAccountSortField>([
  [ChartOfAccountsSortableAccessorKey.Number, GlAccountSortField.Number],
  [ChartOfAccountsSortableAccessorKey.Title, GlAccountSortField.Title],
  [ChartOfAccountsSortableAccessorKey.ParentAccount, GlAccountSortField.ParentAccount],
  [ChartOfAccountsSortableAccessorKey.Type, GlAccountSortField.Type],
])
